import { Injectable } from '@angular/core';
import { AlertsService } from './alerts.service';


declare global {
  interface Window {
    PeripheralBridge?: {
      //Demo Functions
      startOperation: () => string;
      stopOperation: () => string;

      //Scanner Functions
      frontScan: () => void;
      getScanResult: () => string;

      //Printer Functions
      printerSubpoena: (json: String) => void;
      printerDriverLicenseRetention: (json: String) => void;

      //File Functions
      openNativeFileChooser: () => void;
      saveEvidenceList: (evidenceListJson: String,fileFolder: String) => boolean;
      saveAnnexList: (annexListJson: String,fileFolder: String) => boolean;
      deleteEvidenceFiles(idInfractionNumber: string, fileName: string): boolean;
      deleteEvidenceFiles(idInfractionNumber: string): boolean;
      saveBase64ToFile: (base64Url: String,type: String,idInfractionNumber: String) => string;
      getEvidenceFilesAsJson: (idInfractionNumber: string) => string;
      uploadEvidencesToS3: (idInfractionNumber: String,apiUrlBase: String,tokenApp: String,tokenWeb: String) => void;
      downloadS3Images: () => void;
      downloadPrintPdfFromS3: (pdfUrl: String) => void;
      getBase64FromPath: (filePath: String) => string;
      openEvidenceUri: (evidenceUri: String) => void;
      getSignatureBase64FromPath: (path: String, callbackName: String) => void;
     

      //SharedPreferences Functions
      saveData: (key: string, value: string) => void;
      getData: (key: string) => string | null;
      deleteData: (key: string) => void;

      //Network Functions
      isNetworkAvailable: () => boolean;

      //Location Functions
      getUserLocation: (online: Boolean) => void;

      //Device Info Functions
      getAndroidId: () => string;
      getAppVersion: () => string;
      isProduction: () => boolean;

      // Disponibles desde el APK con autoactualización (versiones anteriores no las tienen)
      getAppVersionCode?: () => number;
      getAppPackage?: () => string;
      getDeviceModel?: () => string;
      getAndroidVersion?: () => string;
      checkForUpdates?: () => void;

    };

  }
}


@Injectable({
  providedIn: 'root'
})


export class PeripheralBridgeService {


  constructor(private alertServices: AlertsService) {}

    // Demo Functions
    startOperation(): void {
      if (window.PeripheralBridge) {
        window.PeripheralBridge.startOperation();
      } else {
        this.alertServices.openSimpleAlert('error', 'PeripheralBridge no disponible');
      }
    }
  
    stopOperation(): void {
      if (window.PeripheralBridge) {
        window.PeripheralBridge.stopOperation();
      } else {
        this.alertServices.openSimpleAlert('error', 'PeripheralBridge no disponible');
      }
    }
    // Demo Functions

    // Scanner Functions
    frontScan() : string{
      if (window.PeripheralBridge) {
        try {
          window.PeripheralBridge.frontScan();
          const result = window.PeripheralBridge.getScanResult();
          if (result) {
            return result;
          } else {
            return 'No se obtuvo código';
          }
        } catch (error) {
          this.alertServices.openSimpleAlert('error', 'Error durante el escaneo');
          return 'Error durante el escaneo';
        }
      } else {
        this.alertServices.openSimpleAlert('error', 'PeripheralBridge no disponible');
        return 'No se obtuvo código';
      }
    }


    // Scanner Functions

   // Printer Functions
    printerSubpoena(json: String): void {
      if (window.PeripheralBridge) {
        window.PeripheralBridge.printerSubpoena(json);
      } else {
        this.alertServices.openSimpleAlert('error', 'PeripheralBridge no disponible');
      }
    }

    printerDriverLicenseRetention(json: String): void {
      if (window.PeripheralBridge) {
        window.PeripheralBridge.printerDriverLicenseRetention(json);
      } else {
        this.alertServices.openSimpleAlert('error', 'PeripheralBridge no disponible');
      }
    }
   // Printer Functions

  // File Functions
  openNativeFileChooser(): void {
    if (window.PeripheralBridge) {
      window.PeripheralBridge.openNativeFileChooser();
    } else {
      this.alertServices.openSimpleAlert('error', 'PeripheralBridge no disponible');
    }
  }
  
  saveEvidenceList(evidenceListJson: string, fileFolder: string): boolean {
    if (window.PeripheralBridge) {
      return window.PeripheralBridge.saveEvidenceList(evidenceListJson, fileFolder);
    } else {
      this.alertServices.openSimpleAlert('error', 'PeripheralBridge no disponible');
      return false;
    }
  }


  saveAnnexList(annexListJson: string, fileFolder: string): boolean {
    if (window.PeripheralBridge) {
      return window.PeripheralBridge.saveAnnexList(annexListJson, fileFolder);
    } else {
      this.alertServices.openSimpleAlert('error', 'PeripheralBridge no disponible');
      return false;
    }
  }

  deleteEvidenceFiles(idInfractionNumber: string, fileName: string = ''): boolean {
    if (window.PeripheralBridge) {
      return window.PeripheralBridge.deleteEvidenceFiles(idInfractionNumber, fileName);
    } else {
      this.alertServices.openSimpleAlert('error', 'PeripheralBridge no disponible');
      return false;
    }
  }

  saveBase64ToFile(base64Url: string,type: string,idInfractionNumber: string): string {
    if (window.PeripheralBridge) {
      return window.PeripheralBridge.saveBase64ToFile(base64Url,type,idInfractionNumber);
    } else {
      this.alertServices.openSimpleAlert('error', 'PeripheralBridge no disponible');
      return "";
    }
  }

  
  getEvidenceFilesAsJson(idInfractionNumber: string): any[] {
    if (window.PeripheralBridge) {
      try {
        const result = window.PeripheralBridge.getEvidenceFilesAsJson(idInfractionNumber);
        return JSON.parse(result); // devuelve un arreglo de objetos con name, absolutePath, etc.
      } catch (error) {
        this.alertServices.openSimpleAlert('error', 'Error al obtener evidencias como JSON');
        return [];
      }
    } else {
      this.alertServices.openSimpleAlert('error', 'PeripheralBridge no disponible');
      return [];
    }
  }

  uploadEvidencesToS3(idInfractionNumber: String,apiUrlBase: String,tokenApp: String,tokenWeb: String): void {
    if (window.PeripheralBridge) {
      try {
        return window.PeripheralBridge.uploadEvidencesToS3(idInfractionNumber,apiUrlBase,tokenApp,tokenWeb);
      } catch (error) {
        this.alertServices.openSimpleAlert('error', 'Error al subir evidencias.');
      }
    } else {
      this.alertServices.openSimpleAlert('error', 'PeripheralBridge no disponible');
    }
  }


  downloadS3Images(): void {
    if (window.PeripheralBridge) {
      window.PeripheralBridge.downloadS3Images();
    } else {
      this.alertServices.openSimpleAlert('error', 'PeripheralBridge no disponible');
      console.error('PeripheralBridge no disponible');
    }
  }

  downloadPrintPdfFromS3(pdfUrl: String): void {
    if (window.PeripheralBridge) {
      window.PeripheralBridge.downloadPrintPdfFromS3(pdfUrl);
    } else {
      this.alertServices.openSimpleAlert('error', 'PeripheralBridge no disponible');
      console.error('PeripheralBridge no disponible');
    }
  }


  getBase64FromPath(filePath: string): string {
    if (window.PeripheralBridge && window.PeripheralBridge.getBase64FromPath) {
      try {
        return window.PeripheralBridge.getBase64FromPath(filePath);
      } catch (error) {
        this.alertServices.openSimpleAlert('error', 'Error al obtener base64 del archivo');
        return '';
      }
    } else {
      this.alertServices.openSimpleAlert('error', 'PeripheralBridge no disponible');
      return '';
    }
  }

  openEvidenceUri(evidenceUri: String): void {
    if (window.PeripheralBridge) {
      window.PeripheralBridge.openEvidenceUri(evidenceUri);
    } else {
      this.alertServices.openSimpleAlert('error', 'PeripheralBridge no disponible');
    }
  }

  getSignatureBase64FromPath(path: String, callbackName: String): void {
    if (window.PeripheralBridge) {
      window.PeripheralBridge.getSignatureBase64FromPath(path,callbackName);
    } else {
      this.alertServices.openSimpleAlert('error', 'PeripheralBridge no disponible');
    }
  }
  
  // File Functions

  // SharedPreferences Functions
  saveData(key: string, value: string): void {
    if (window.PeripheralBridge) {
      try {
        window.PeripheralBridge.saveData(key, JSON.stringify(value));
      } catch (error) {
        this.alertServices.openSimpleAlert('error', 'Error guardando datos');
      }
    } else {
      localStorage.setItem(key, JSON.stringify(value));
      
    }
  }

  getData(key: string): string | null {
    let data;
    
    if (window.PeripheralBridge) {
      try {
        data = window.PeripheralBridge.getData(key);
        return data;
      } catch (error) {
        this.alertServices.openSimpleAlert('error', 'Error recuperando datos');
        return null;
      }
    } else {
      try {
        data = localStorage.getItem(key);
        return data;
      } catch (error) {
        this.alertServices.openSimpleAlert('error', 'Error recuperando datos');
        return null;
      }
    }
  }

  deleteData(key: string): void {
    if (window.PeripheralBridge) {
      try {
        window.PeripheralBridge.deleteData(key);
      } catch (error) {
        this.alertServices.openSimpleAlert('error', 'Error eliminando datos');
      }
    } else {
       localStorage.removeItem(key);
    }
  }

  // SharedPreferences Functions


  //Network Functions
  isNetworkAvailable(): boolean{
    let hasInternet = false ;

    if (window.PeripheralBridge) {
      hasInternet = window.PeripheralBridge.isNetworkAvailable();
    } else {
      hasInternet = true;
      //this.alertServices.openSimpleAlert('error', 'PeripheralBridge no disponible');
    }

    return hasInternet;
  }

  //Network Functions

  //Location Functions

  
  getUserLocation(online: Boolean): void {
    if (window.PeripheralBridge) {
       window.PeripheralBridge.getUserLocation(online);
    } else {
      this.alertServices.openSimpleAlert('error', 'PeripheralBridge no disponible');
    }
  }
  
  //Location Functions

  // Device Info Functions
  getAndroidId(): string{
    let androidId = '';

    if (window.PeripheralBridge) {
      androidId = window.PeripheralBridge.getAndroidId();
    } else {
      androidId = 'PeripheralBridge no disponible';
    }

    return androidId;
  }

  getAppVersion(): string{
    let appVersion = '';

    if (window.PeripheralBridge) {
      appVersion = window.PeripheralBridge.getAppVersion();
    } else {
      appVersion = 'PeripheralBridge no disponible';
    }

    return appVersion;
  }

  isProduction(): boolean{
    let isProduction = false;

    if (window.PeripheralBridge) {
      isProduction = window.PeripheralBridge.isProduction();
    }
    
    return isProduction;
  }

  // Device Info Functions

}
